/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BasePromoBannerFragment} from '@amblique/contentful/app/contentful/fragments/promo-banner/base-promo-banner.fragment';
import {PromoBannerItemFragment} from '@amblique/contentful/app/contentful/fragments/promo-banner-item/promo-banner-item.fragment';

export const FullPromoBannerFragment = gql`
  ${BasePromoBannerFragment}
  ${PromoBannerItemFragment}

  fragment FullPromoBannerFragment on PromoBanner {
    ...BasePromoBannerFragment

    itemsCollection {
      items {
        __typename
        ... on PromoBannerItem {
          ...PromoBannerItemFragment
        }
      }
    }
  }
`;
